interface CloudPaymentsData {
    CloudPayments: {
        CustomerReceipt: null;
        recurrent: {
            interval: 'Month';
            period: number;
            customerReceipt: null;
        };
        buyer: string;
        recipient: string;
    };
}

interface PaymentOptions {
    publicId: string;
    description: string;
    amount: number;
    currency: string;
    accountId: string;
    data: CloudPaymentsData;
}

interface CloudPaymentsWidget {
    charge: (
        options: PaymentOptions,
        onSuccess: (options: any) => void,
        onError: (reason: any, options: any) => void
    ) => void;
    close: () => void;
}
export interface FlowerOrderPaymentParams {
    publicKey: string;
    userId: string;
    amount: number;
    orderId: number;
    onSuccess?: (options: any) => void;
    onError?: (reason: any, options?: any) => void;
}
interface CloudPaymentsWindow extends Window {
    cp?: {
        CloudPayments: new () => CloudPaymentsWidget;
    };
}

declare const window: CloudPaymentsWindow;
let currentWidget: CloudPaymentsWidget | null = null;
let isProgrammaticClose = false;
export interface SubscriptionParams {
    publicKey: string;
    userId: string;
    amount?: number;
    description?: string;
    onSuccess?: (options: any) => void;
    onError?: (reason: any, options?: any) => void;
    period?: 1 | 6 | 12;
}

export interface GiftSubscriptionParams extends SubscriptionParams {
    recipientId: string;
}

const getCloudPayments = (): CloudPaymentsWidget | null => {
    if (window.cp?.CloudPayments) {
        return new window.cp.CloudPayments();
    }

    console.error('CloudPayments не найден. Убедитесь что скрипт загружен в HTML.');
    return null;
};

export const closeCurrentWidget = (): boolean => {
    if (currentWidget) {
        try {
            isProgrammaticClose = true;
            currentWidget.close();
            currentWidget = null;
            return true;
        } catch (error) {
            console.warn('Ошибка при закрытии виджета CloudPayments:', error);
            currentWidget = null;
            isProgrammaticClose = false;
            return false;
        }
    }
    return false;
};

export const createSubscription = async ({
    publicKey,
    userId,
    amount = 299, // По умолчанию 299 рублей
    description = 'Подписка на ДПС-Контроль',
    onSuccess,
    onError,
    period = 1,
}: SubscriptionParams): Promise<void> => {
    try {
        const widget = getCloudPayments();

        if (!widget) {
            throw new Error('CloudPayments виджет недоступен');
        }
        currentWidget = widget;
        const data: CloudPaymentsData = {
            CloudPayments: {
                CustomerReceipt: null,
                recurrent: {
                    interval: 'Month',
                    period: period,
                    customerReceipt: null
                },
                buyer: userId,
                recipient: userId
            }
        };

        console.log('💳 Инициализация CloudPayments с параметрами:', {
            publicId: publicKey,
            userId,
            amount
        });

        widget.charge({
            publicId: publicKey,
            description,
            amount,
            currency: 'RUB',
            accountId: userId,
            data: data
        },
            function (options: any) {
                console.log('✅ Успешная оплата:', options);
                currentWidget = null;

                // Закрываем клавиатуру Telegram после успешной оплаты
                if (window.Telegram?.WebApp) {
                    try {
                        if (window.Telegram.WebApp.MainButton) {
                            window.Telegram.WebApp.MainButton.hideProgress();
                            window.Telegram.WebApp.MainButton.hide();
                        }
                        // Убираем фокус с активного элемента
                        if (document.activeElement instanceof HTMLElement) {
                            document.activeElement.blur();
                        }
                    } catch (e) {
                        console.warn('Не удалось закрыть клавиатуру:', e);
                    }
                }

                if (onSuccess) onSuccess(options);
            },
            function (reason: any, options: any) {
                console.log('❌ Ошибка оплаты:', reason, options);
                currentWidget = null;

                if (isProgrammaticClose) {
                    isProgrammaticClose = false;
                    return;
                }

                if (onError) onError(reason, options);
            });

    } catch (error) {
        console.error('❌ Ошибка при инициализации CloudPayments:', error);
        currentWidget = null;
        if (onError) onError(error);
    }
};


export const createGiftSubscription = async ({
    publicKey,
    userId,
    amount = 299,
    description = 'Подарочная подписка на ДПС-Контроль',
    recipientId,
    onSuccess,
    onError,
    period = 1
}: GiftSubscriptionParams): Promise<void> => {
    try {
        const widget = getCloudPayments();

        if (!widget) {
            throw new Error('CloudPayments виджет недоступен');
        }
        currentWidget = widget;
        const data: CloudPaymentsData = {
            CloudPayments: {
                CustomerReceipt: null,
                recurrent: {
                    interval: 'Month',
                    period: period,
                    customerReceipt: null
                },
                buyer: userId,
                recipient: recipientId
            }
        };

        console.log('🎁 Инициализация подарочной подписки:', {
            publicId: publicKey,
            buyer: userId,
            recipient: recipientId
        });

        widget.charge({
            publicId: publicKey,
            description,
            amount,
            currency: 'RUB',
            accountId: userId,
            data: data
        },
            function (options: any) {
                console.log('✅ Успешная подарочная оплата:', options);
                currentWidget = null;

                // Закрываем клавиатуру Telegram после успешной оплаты
                if (window.Telegram?.WebApp) {
                    try {
                        if (window.Telegram.WebApp.MainButton) {
                            window.Telegram.WebApp.MainButton.hideProgress();
                            window.Telegram.WebApp.MainButton.hide();
                        }
                        // Убираем фокус с активного элемента
                        if (document.activeElement instanceof HTMLElement) {
                            document.activeElement.blur();
                        }
                    } catch (e) {
                        console.warn('Не удалось закрыть клавиатуру:', e);
                    }
                }

                if (onSuccess) onSuccess(options);
            },
            function (reason: any, options: any) {
                console.log('❌ Ошибка оплаты:', reason, options);
                currentWidget = null;

                if (isProgrammaticClose) {
                    isProgrammaticClose = false;
                    return;
                }

                if (onError) onError(reason, options);
            });

    } catch (error) {
        console.error('❌ Ошибка при инициализации подарочной подписки:', error);
        currentWidget = null;
        if (onError) onError(error);
    }
};

// Вспомогательная функция для проверки доступности CloudPayments
export const isCloudPaymentsAvailable = (): boolean => {
    return !!(window.cp?.CloudPayments);
};

// Функция для ожидания загрузки CloudPayments
export const waitForCloudPayments = (timeout: number = 5000): Promise<boolean> => {
    return new Promise((resolve) => {
        if (isCloudPaymentsAvailable()) {
            resolve(true);
            return;
        }

        const startTime = Date.now();
        const checkInterval = setInterval(() => {
            if (isCloudPaymentsAvailable()) {
                clearInterval(checkInterval);
                resolve(true);
            } else if (Date.now() - startTime > timeout) {
                clearInterval(checkInterval);
                resolve(false);
            }
        }, 100);
    });
};

export const payFlowerOrder = async ({
    publicKey,
    userId,
    amount,
    orderId,
    onSuccess,
    onError,
}: FlowerOrderPaymentParams): Promise<void> => {
    try {
        const widget = getCloudPayments();
        if (!widget) {
            throw new Error('CloudPayments виджет недоступен');
        }
        currentWidget = widget;

        console.log('Запуск оплаты заказа цветов:', {
            orderId,
            amount,
            externalId: `ORDER-${orderId}`
        });

        widget.charge({
            publicId: publicKey,
            description: `Заказ цветов №${orderId}`,
            amount,
            currency: 'RUB',
            accountId: userId,
            invoiceId: `ORDER-${orderId}`,
            data: {
                CloudPayments: {
                    CustomerReceipt: null
                }
            }
        } as any,
            function (options: any) {
                console.log('Заказ оплачен:', options);
                currentWidget = null;

                // Закрываем клавиатуру Telegram после успешной оплаты
                if (window.Telegram?.WebApp) {
                    try {
                        if (window.Telegram.WebApp.MainButton) {
                            window.Telegram.WebApp.MainButton.hideProgress();
                            window.Telegram.WebApp.MainButton.hide();
                        }
                        // Убираем фокус с активного элемента
                        if (document.activeElement instanceof HTMLElement) {
                            document.activeElement.blur();
                        }
                    } catch (e) {
                        console.warn('Не удалось закрыть клавиатуру:', e);
                    }
                }

                if (onSuccess) onSuccess(options);
            },
            function (reason: any, options: any) {
                console.log('Ошибка оплаты:', reason, options);

                currentWidget = null;

                if (isProgrammaticClose) {
                    isProgrammaticClose = false;
                    return;
                }

                if (onError) onError(reason, options);
            });

    } catch (error) {
        console.error('Ошибка при инициализации оплаты:', error);
        currentWidget = null;
        if (onError) onError(error);
    }
};

export interface GiftOrderPaymentParams {
    publicKey: string;
    userId: string;
    amount: number;
    giftId: number;
    giftPeriod: string;
    onSuccess?: (options: any) => void;
    onError?: (reason: any, options?: any) => void;
}

export const payGiftOrder = async ({
    publicKey,
    userId,
    amount,
    giftId,
    giftPeriod,
    onSuccess,
    onError,
}: GiftOrderPaymentParams): Promise<void> => {
    try {
        const widget = getCloudPayments();
        if (!widget) {
            throw new Error('CloudPayments виджет недоступен');
        }
        currentWidget = widget;

        console.log('🎁 Запуск оплаты подарка:', {
            giftId,
            amount,
            giftPeriod,
            externalId: `UGIFT-${giftId}`
        });

        widget.charge({
            publicId: publicKey,
            description: `Подарочная подписка ${giftPeriod}`,
            amount,
            currency: 'RUB',
            accountId: userId,
            invoiceId: `UGIFT-${giftId}`,
            data: {
                CloudPayments: {
                    CustomerReceipt: null
                }
            }
        } as any,
            function (options: any) {
                console.log('✅ Подарок оплачен:', options);
                currentWidget = null;

                // Закрываем клавиатуру Telegram после успешной оплаты
                if (window.Telegram?.WebApp) {
                    try {
                        if (window.Telegram.WebApp.MainButton) {
                            window.Telegram.WebApp.MainButton.hideProgress();
                            window.Telegram.WebApp.MainButton.hide();
                        }
                        // Убираем фокус с активного элемента, чтобы закрыть клавиатуру
                        if (document.activeElement instanceof HTMLElement) {
                            document.activeElement.blur();
                        }
                    } catch (e) {
                        console.warn('Не удалось закрыть клавиатуру:', e);
                    }
                }

                if (onSuccess) onSuccess(options);
            },
            function (reason: any, options: any) {
                console.log('❌ Ошибка оплаты подарка:', reason, options);

                currentWidget = null;

                if (isProgrammaticClose) {
                    isProgrammaticClose = false;
                    return;
                }

                if (onError) onError(reason, options);
            });

    } catch (error) {
        console.error('❌ Ошибка при инициализации оплаты подарка:', error);
        currentWidget = null;
        if (onError) onError(error);
    }
};